import React from 'react';

import GenericForm from 'components/GenericForm';
import type {
	JulaComponentProps,
	PartialPopoverProps,
} from 'lib/component-props';
import type { GenericFormFields } from 'models/sitecore';

type Props = JulaComponentProps & {
	fields?: GenericFormFields;
	// just to show that it's in a partial popover
	// eslint-disable-next-line react/no-unused-prop-types
	partialProps?: PartialPopoverProps;
};

export default function AccountJulaClubSignupForm({ fields }: Props) {
	if (!fields) {
		return null;
	}
	return (
		<GenericForm
			shouldCloseOnOutsideClick={false}
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
AccountJulaClubSignupForm.displayName = 'AccountJulaClubSignupForm';
